<template>
  <wrap-container>
    <help-title title="Asistencia al Viajero" />

    <help-list-container>
      <help-list-item tituloLista="Emergencia Médica Internacional:">
        Para acceder a los Servicios de Emergencia Médica Internacional, deberás
        solicitar el certificado de viaje de tu tarjeta de crédito Visa, antes
        del comienzo del viaje.
        <br />
        Podes emitirlo desde el portal de beneficios de Visa, ingresando en
        <a id="contactForm" href="https://www.visa.com/portalbeneficios"
          >Portal Beneficios</a
        >
        seleccionado las siguientes opciones:
        <br />
        <strong
          >Certificados -> Generar Certificado -> Certificado seguro de
          viaje.</strong
        >
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Para más información o para realizar un reclamo, acerca de los
        <strong>"Servicios médicos de emergencia"</strong> de tus tarjetas Visa
        Premium/Signature
        <a
          id="contactForm"
          href="https://visabenefitslac.axa-assistance.us/benefits/C_C_AR/EMC_Emergency_Medical_Assistance_11"
          >ingresá aquí</a
        >.<br />
        Con respecto a la tarjeta MasterCard, podrás solicitar el certificado de
        cobertura llamando al 0800-266-1613 de lunes a viernes de 8 a 21 hs.<br />
        Para mayor información también podes acceder a
        <a
          id="contactForm"
          href="https://www.bbva.com.ar/personas/productos/tarjetas/credito/asistencia-al-viajero.html"
          >Asistencia al Viajero</a
        >
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
